export const SIGNING_REQUEST = 'SIGNING_REQUEST';
export const SIGNING_SUCCESS = 'SIGNING_SUCCESS';
export const SIGNING_FAILED = 'SIGNING_FAILED'; 

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED'; 

export const EMAILCHECK_REQUEST = 'EMAILCHECK_REQUEST';
export const EMAILCHECK_SUCCESS = 'EMAILCHECK_SUCCESS';
export const EMAILCHECK_FAILED = 'EMAILCHECK_FAILED'; 


export const OTP_REQUEST = 'OTP_REQUEST';
export const OTP_SUCCESS = 'OTP_SUCCESS';
export const OTP_FAILED = 'OTP_FAILED'; 

export const FORGETOTP_REQUEST = 'FORGETOTP_REQUEST';
export const FORGETOTP_SUCCESS = 'FORGETOTP_SUCCESS';
export const FORGETOTP_FAILED = 'FORGETOTP_FAILED'; 

export const FORGETEMAIL_REQUEST = 'FORGETEMAIL_REQUEST';
export const FORGETEMAIL_SUCCESS = 'FORGETEMAIL_SUCCESS';
export const FORGETEMAIL_FAILED = 'FORGETEMAIL_FAILED'; 